import { render, staticRenderFns } from "./yis.vue?vue&type=template&id=5b1d1084&scoped=true"
import script from "./yis.vue?vue&type=script&lang=js"
export * from "./yis.vue?vue&type=script&lang=js"
import style0 from "./yis.vue?vue&type=style&index=0&id=5b1d1084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d1084",
  null
  
)

export default component.exports